<template>
  <!-- Section 1 -->
  <div class="">
    <div class="mt-2.5">
      <label for="phone">
        Phone number
        <span class="text-red-400">*</span>
      </label>
      <input
        type="number"
        class="input"
        id="phone"
        pattern="/\d*$/"
        onKeyPress="if(this.value.length==11) return false;"
        placeholder="080xxxxxxxx"
        v-model="form.phone"
      />
    </div>

    <div class="mt-5">
      <label for="nin">
        National Identification Number (NIN)
        <span class="text-red-400">*</span>
      </label>
      <input
        type="number"
        class="input"
        id="nin"
        pattern="/\d*$/"
        onKeyPress="if(this.value.length==11) return false;"
        placeholder="Enter your NIN"
        v-model="form.nin"
      />
    </div>

    <div class="flex justify-center mt-8 pb-3">
      <button
        :disabled="!stepOneReady || verifying"
        @click="confirmNin"
        class="bg-oneGreen text-white w-full text-center py-3 rounded font-semibold text-xl"
      >
        <spinner v-if="verifying" />
        <span>Next</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NinStep1",

  data() {
    return {
      verifying: false,
      form: {
        nin: null,
        phone: null,
      },
    };
  },
  computed: {
    stepOneReady() {
      return this.ninReady && Boolean(this.form.phone);
    },
    ninReady() {
      return Boolean(this.form.nin) && this.form.nin.length === 11;
    },
  },
  methods: {
    async confirmNin() {
      try {
        this.verifying = true;
        this.saveData({
          ...this.form,
        });
        this.verifying = false;

        this.$store.commit("staff/saveData", { key: "bvnNinStep", data: 2 });
      } catch (error) {
        this.fetching = false;
        console.log(error);
      }
    },

    saveData(data) {
      this.$store.commit("staff/updateNINData", data);
    },
  },
};
</script>
